// @ts-check
import React from 'react'
import { CustomSelect } from './CustomSelect/CustomSelect'
import { DefaultSelect } from './DefaultSelect/DefaultSelect'
import { isMobile } from '../../components/api'

/**
 * @param {{
 * placeholder: string,
 * label: string,
 * name: string,
 * onChange: {(event: React.ChangeEvent): void},
 * options: OptionProps[],
 * value: string,
 * valid: boolean,
 * info: string,
 * error?: string,
 * showLabelAsPlaceholder?: boolean
 * }} props
 */
const Select = (props) => {
  return !isMobile() ? <CustomSelect {...props} /> : <DefaultSelect {...props} />
}

export { Select }
